import { useRef, useState, useEffect } from 'react'
import * as S from './styles'
import IconClose from '../../../assets/icons/icon-close.svg'
import NewCard from '../NewCard'

import FormAddNewCreditCard from '../FormAddNewCreditCard'
import { useDispatch, useSelector } from 'react-redux'
import CreditCard from '../CreditCard'
import pagamento from '../../../api/pagamento'
import FormCVV from '../FormCVV'
import { useToast } from '../../../hooks/toast'
import { converterNegociacaoCartao } from '../../../pages/Negociacoes/fetch'
import { useHistory } from 'react-router-dom'
import ProdutosEsgotadosMessage from '../ProdutosEsgotadosMessage'

const ProdutosEsgotadosModal = ({ showModal, setShowModal, message }) => {
  const modalRef = useRef()

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false)
    }
  }

  return (
    <>
      {showModal ? (
        <S.Background onClick={closeModal}>
          <S.ModalWrapper>
            <S.ContentWrapper>
              <ProdutosEsgotadosMessage
                message={message}
              ></ProdutosEsgotadosMessage>
            </S.ContentWrapper>

            <S.HeaderModalClose
              className="header-modal-close"
              aria-label="Close modal"
              onClick={() => {
                setShowModal((prev) => !prev)
              }}
            >
              {/* <Icon name="icon-close" /> */}
              <img src={IconClose} alt="" />
            </S.HeaderModalClose>
          </S.ModalWrapper>
        </S.Background>
      ) : null}
    </>
  )
}

export default ProdutosEsgotadosModal
